import type { DepartureTiming } from './types'

export function departureTiming(departureDate: string | undefined, now: Date = new Date()): DepartureTiming {
  if (!departureDate) return 'BEFORE_DEPARTURE'
  return now >= new Date(departureDate) ? 'AFTER_DEPARTURE' : 'BEFORE_DEPARTURE'
}

export function daysUntilDeparture(departureDate: string | undefined, now: Date = new Date()): number {
  if (!departureDate) return Infinity
  return (new Date(departureDate).getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
}

export function hoursUntilDeparture(departureDate: string | undefined, now: Date = new Date()): number {
  if (!departureDate) return Infinity
  return (new Date(departureDate).getTime() - now.getTime()) / (1000 * 60 * 60)
}
